import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { BoVisitor } from '../../bos/bo-visitor.js'
import { Block } from '../index.js'
import { DataTableBlock } from './data-table-block.js'
import { ContentAreaBlock } from './content-area-block.js'
import { TabGroupBlock } from './tab-group-block.js'
import { TextOrExpression_assumeExpression } from '../../data/text-or-code.js'

@jsonClass('TabGroupTabBlock')
export class TabGroupTabBlock extends Block {
	// @jsonProperty(String)
	// @EditorGeneralInput({
	// 	inputType: 'input',
	// 	order: 1,
	// 	label: 'Column name',
	// 	contentType: 'text',
	// 	elementType: 'input',
	// 	isMandatory: () => true,
	// })
	// name: string = ''

	@jsonProperty(TextOrExpression_assumeExpression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 2,
		label: 'Label',
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
		isMandatory: () => true,
		alternativeContentAreaName: 'label',
	})
	labelCode = new TextOrExpression_assumeExpression('Tab', 'T')

	@jsonProperty(TextOrExpression_assumeExpression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 3,
		label: 'Tab ID',
		tooltip: () => ({
			text: 'Only used if you want to programmatically set or get the selected tab',
		}),
		codeLanguage: 'ts',
		tsReturnType: () => 'string',
		editorSize: 'singleline',
		isBinding: false,
		isMandatory: () => false,
	})
	tabIdCode = new TextOrExpression_assumeExpression('', 'T')

	@jsonProperty()
	@ScreenEditorInput({
		inputType: 'checkbox',
		order: 4,
		label: 'Load content lazily',
		tab: 'Advanced',
	})
	loadLazily: boolean = false

	constructor(init: Partial<TabGroupTabBlock> = {}) {
		super()
		this.init(init)
	}

	static createNewForEditor(): Block {
		return new this()
	}

	getBlockName(): string {
		return 'Tab'
	}

	getEditorTitle() {
		return `${super.getEditorTitle()} ${this.labelCode.content ?? ''}`
	}

	canHaveParent(parent: Block): boolean {
		return parent instanceof TabGroupBlock
	}

	protected visitThisWithBoVisitor(
		visitor: BoVisitor,
		pathPrefix: (string | number)[],
	): void {}

	getEditorCategory(): string {
		return 'Screen Structure'
	}
}
